import React from 'react'
import {BrowserRouter as Router,Switch,Route} from 'react-router-dom';
import {Link} from "react-router-dom"
import styles from './Update.module.css'
import UpdateEvent from './UpdateEvent';
import UpdateProject from './UpdateProject';
import * as b from 'react-bootstrap'
import UpdateTeam from "./UpdateTeam";
import UpdateHome from './UpdateHome';

function UpdatePage() {
    return (
        <Router>
        <div style={{paddingTop:"35px"}}>
        <b.Container fluid>
        {/* style="display: flex; flex-wrap: wrap" */}
        <b.Row className={styles.row}>
            <b.Col xs={3} className={styles.sidebar} md={2}>
                <Link to="/update" className={styles.Link}><h4>New Events</h4></Link><br /><br />
                <Link to="/update/project" className={styles.Link}><h4>New Project</h4></Link><br /><br />
                <Link to="/update/team" className={styles.Link}><h4>Update Team</h4></Link><br /><br />
                <Link to="/update/home" className={styles.Link}><h4>Update Home Page</h4></Link><br /><br />
            </b.Col>
            <b.Col xs={9} md={10}>
                <Switch>
                    <Route path="/update" exact  component={UpdateEvent} />
                    <Route path="/update/project" exact component={UpdateProject} />
                    <Route path="/update/team" exact component={UpdateTeam} />
                    <Route path="/update/home" exact component={UpdateHome} />
                </Switch>
                {/* <UpdateEvent></UpdateEvent>
                <UpdateProject></UpdateProject> */}
            </b.Col>
        </b.Row>
        </b.Container>
        </div>
        </Router>
    )
}

export default UpdatePage
